import { useSelector } from 'react-redux';
import styles from './index.module.scss';
import LeftPanel from './LeftPanel';
import RightPanel from './RightPanel';
import { RootState } from '@cp/src/store';
import { TAB_KEYS } from './constant';
import { useState } from 'react';

const Approvals = () => {
  const isAgentIdCardDetailsVisible = useSelector(
    (state: RootState) => state?.common?.featureFlags?.isAgentIdCardDetailsVisible
  );

  const getInitialTabKey = () => {
    return isAgentIdCardDetailsVisible ? TAB_KEYS.ID_CARDS : TAB_KEYS.PAN_CARDS;
  };
  const [selectedTabKey, setSelectedTabKey] = useState(getInitialTabKey);

  return (
    <div className={styles.mainContainer}>
      <LeftPanel setSelectedTabKey={setSelectedTabKey} selectedTabKey={selectedTabKey} />
      <RightPanel selectedTabKey={selectedTabKey} />
    </div>
  );
};

export default Approvals;
